import redirect from './redirect';
import segment from './segment';
import { currentUser as currentUserMiddleware } from './currentUser';
import { featureUserSettings } from './featureUserSettings';
import { fillAdvisor } from './fillAdvisor';
import { fingerprinter } from './fingerprinter';
import { imageUpload } from './imageUpload';
import { logger } from './logger';
import { magicAlgorithmData } from './magicAlgorithm';
import { pagination } from './pagination';
import { requirementsTags } from './requirementsTags';
import { notifications } from './notifications';
import {
  messageDispatcherMiddleware,
  messageReceiverMiddleware,
} from './postMessage';
import { customerPermissions } from './customerPermissions';
import { browserStorage } from './browserStorage';
// must be before any content activity; in sort order
const setupMiddleware = [
  pagination,
  currentUserMiddleware,
  featureUserSettings,
  customerPermissions,
];

// middleware acting on content; unsorted
const contentMiddleware = [
  messageDispatcherMiddleware,
  messageReceiverMiddleware,
  fillAdvisor,
  imageUpload,
  magicAlgorithmData,
  notifications,
  requirementsTags,
  redirect,
  browserStorage,
  ...segment,
];

const middlewares = setupMiddleware.concat(contentMiddleware);
const middlewaresDev = middlewares.concat([fingerprinter, logger]);

export default process.env.NODE_ENV === 'development'
  ? middlewaresDev
  : middlewares;
